// main.js
// import Vue from 'vue';
// import App from './App.vue';

// 全局加载统计脚本
(function () {
  window._mtj = window._mtj || [];
  const script = document.createElement('script');
  script.src = 'https://node94.aizhantj.com:21233/tjjs/?k=cqdbu4ipkyd';
  script.async = true;
  document.head.appendChild(script);
})();

// new Vue({
//   render: h => h(App),
// }).$mount('#app');



// WEBPACK FOOTER //
// ./src/helpers/Access-Statistics.js